import{useState,useEffect} from "react";
import ImageWithBasePath from "../../../../core/img";
import {all_routes} from "../../../router/all_routes";
/* -- biz9 import start -- */
import {Str,Log} from "biz9-utility";
import {Page_Logic,Portal_Type,Portal_Url,Portal_Title,Sub_Value_Logic,Portal_Value_Type,Portal_Page,Portal_Remote_Page,Portal_Remote_Data,Portal_Remote_CMS,Portal_Table} from "biz9-portal-app";
import {Image_Type,Image_Table} from "biz9-image";
import {Field,Message,Title,Type,Url} from "../../../../constant";
import {App,Data,Dashboard,Event,Image,Style,Service_Industry,Template,Storage,System,User} from "../../../../project";
import {Data_Logic} from "biz9-data-app";
/* -- biz9 import end -- */

const Dashboard_User_Home = () => {
    const [user,setUser] = useState(User.get());
    const [val_sub_page_title,setValSubPageTitle] = useState("Dashboard");
    const [val_new_app_count,setValNewAppCount] = useState("0");
    const [val_development_app_count,setValDevelopmentAppCount] = useState("0");
    const [val_active_app_count,setValActiveAppCount] = useState("0");
    useEffect(() => {
        Storage.post_dashboard_side_bar(Title.USER_SIDE_BAR_DASHBOARD);
        Storage.post_dashboard_type_user();
        //get_data();
    },[]);
    async function get_data() {
        let search = Data_Logic.get_search(Portal_Table.APP,{user_id:user.id});
        let option = {};
	    let [response,data] = await Portal_Remote_Data.search(App.get_url(Portal_Url.DATA_SEARCH),search,option);
        bind_field(data);
   };
  async function bind_field(data) {
      /*
        let new_appz_filter = data.items.filter(item_find=>item_find.status_type === App.get_app_status_type_by_title(Title.APP_STATUS_TYPE_NEW).value);
        let development_appz_filter = data.items.filter(item_find=> item_find.status_type === App.get_app_status_type_by_title(Title.APP_STATUS_TYPE_DEVELOPMENT).value || item_find.status_type === App.get_app_status_type_by_title(Title.APP_STATUS_TYPE_STAGING).value);
        let active_appz_filter = data.items.filter(item_find=> item_find.status_type === App.get_app_status_type_by_title(Title.APP_STATUS_TYPE_BALANCE_DUE).value || item_find.status_type === App.get_app_status_type_by_title(Title.APP_STATUS_TYPE_PRODUCTION).value || item_find.status_type === App.get_app_status_type_by_title(Title.APP_STATUS_TYPE_PLANNED_DOWNTIME).value || item_find.status_type === App.get_app_status_type_by_title(Title.APP_STATUS_TYPE_PLANNED_DOWNTIME).value);
        setValNewAppCount(new_appz_filter.length);
        setValDevelopmentAppCount(development_appz_filter.length);
        setValActiveAppCount(active_appz_filter.length);
        */
  }
  return (
    <>
      {/* Page Content */}
      <div className="page-wrapper">
        <div className="page-content content pb-0">
          <div className="main-title mb-4">
            <h4>{val_sub_page_title}</h4>
          </div>
          {/* status */}
          <div className="row status-info">
            <div className="col-lg-3 col-md-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-between">
                    <div>
                      <p className="mb-1">New AppZ</p>
                      <h6 className="mb-1">{val_new_app_count}</h6>
                    </div>
                    <span className="bg-primary-transparent status-icon">
                      <i className="ti ti-arrows-maximize" />
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-between">
                    <div>
                      <p className="mb-1">Development AppZ</p>
                      <h6 className="mb-1">{val_development_app_count}</h6>
                    </div>
                    <span className="bg-primary-transparent status-icon">
                      <i className="ti ti-arrows-maximize" />
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-between">
                    <div>
                      <p className="mb-1">Active AppZ</p>
                      <h6 className="mb-1">{val_active_app_count}</h6>
                    </div>
                    <span className="bg-success-transparent status-icon">
                      <i className="ti ti-circle-check" />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* status */}
        </div>
      </div>
      {/* /Page Content */}
    </>
  );
};
export default Dashboard_User_Home;
